import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDateJul = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("g", {
			id: `${__svgrId}-Date Icons`,
			children: /* @__PURE__ */ _jsx("g", {
				id: `${__svgrId}-Icon / Date / July`,
				children: /* @__PURE__ */ _jsxs("g", {
					id: `${__svgrId}-Icons`,
					children: [
						/* @__PURE__ */ _jsx("rect", {
							height: 24.9624,
							id: `${__svgrId}-Rectangle 61`,
							stroke: "white",
							strokeLinejoin: "round",
							strokeWidth: 2.5,
							style: { fill: "var(--sticker-pastel,#FFE29A)" },
							width: 22.4432,
							x: 4.6789,
							y: 3.9967
						}),
						/* @__PURE__ */ _jsx("rect", {
							height: 22.4624,
							id: `${__svgrId}-Rectangle 59`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: {
								fill: "var(--sticker-pastel,#FFE29A)",
								stroke: "var(--sticker-dark,#B87C1F)"
							},
							width: 19.9432,
							x: 5.9289,
							y: 5.2468
						}),
						/* @__PURE__ */ _jsx("rect", {
							fill: "white",
							height: 12.9712,
							id: `${__svgrId}-Rectangle 60`,
							strokeLinejoin: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" },
							width: 19.9432,
							x: 5.9311,
							y: 14.7383
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M11.1332 12.9922 C10.5678 12.9921 10.1065 12.8321 9.7491 12.5122 C9.3971 12.1868 9.2212 11.7201 9.2212 11.1121 L10.4692 11.1122 C10.4798 11.3575 10.5385 11.5468 10.6451 11.6801 C10.7519 11.8081 10.9038 11.8721 11.1011 11.8721 C11.2878 11.8722 11.4292 11.8135 11.5251 11.6961 C11.6265 11.5735 11.6772 11.4055 11.6772 11.1921 L11.6772 7.2962 L12.9331 7.2961 L12.9331 11.1922 C12.9331 11.7735 12.7705 12.2188 12.4452 12.5281 C12.1198 12.8375 11.6825 12.9921 11.1332 12.9922 Z M15.873 12.9921 C15.3503 12.9921 14.921 12.8882 14.585 12.6802 C14.2491 12.4722 14.001 12.1948 13.841 11.8481 C13.681 11.5014 13.601 11.1175 13.601 10.6961 L13.601 7.2961 L14.857 7.2961 L14.857 10.7041 C14.857 11.0668 14.945 11.3468 15.121 11.5442 C15.297 11.7362 15.5557 11.8322 15.897 11.8322 C16.2331 11.8322 16.4916 11.7362 16.673 11.5442 C16.8597 11.3468 16.953 11.0668 16.953 10.7041 L16.953 7.2962 L18.209 7.2961 L18.209 10.6962 C18.209 11.1335 18.137 11.4988 17.993 11.7921 C17.8491 12.0854 17.6597 12.3202 17.4251 12.4961 C17.1957 12.6721 16.9423 12.8002 16.665 12.8802 C16.3931 12.9548 16.129 12.9921 15.873 12.9921 Z M18.8495 12.8961 L18.8495 7.2961 L20.1135 7.2961 L20.1135 11.8002 L22.4015 11.8001 L22.4015 12.8962 L18.8495 12.8961 Z",
							id: `${__svgrId}-JUL`,
							style: { fill: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 34`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 9.942,
							x2: 9.942,
							y1: 15.3986,
							y2: 27.0677
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 38`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 13.9199,
							x2: 13.9198,
							y1: 15.3984,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 36`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5944,
							x2: 25.1531,
							y1: 19.1321,
							y2: 19.1322
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 37`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 6.5949,
							x2: 25.1535,
							y1: 23.0835,
							y2: 23.0835
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 35`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 17.7504,
							x2: 17.7503,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("line", {
							id: `${__svgrId}-Line 39`,
							stroke: "#E0E0E0",
							strokeWidth: 1.5,
							x1: 21.7954,
							x2: 21.7954,
							y1: 15.3985,
							y2: 27.0676
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M12.8152 4.3477 L12.8151 6.1461",
							id: `${__svgrId}-Line 40`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M19.2456 4.3477 L19.2456 6.1461",
							id: `${__svgrId}-Line 41`,
							strokeLinecap: "round",
							strokeWidth: 1.5,
							style: { stroke: "var(--sticker-dark,#B87C1F)" }
						})
					]
				})
			})
		})
	});
};
export default SvgDateJul;
